import { Branch, InventoryLocation } from 'inventory-web'
import { useInventoryLocationsLazyQuery } from '../../../../../../graphql'

export default function useValidateBranchAndName( inventoryLocation?: InventoryLocation, queryOptions?: any ) {
	const [ queryInventoryLocations ] = useInventoryLocationsLazyQuery( queryOptions )

	return async( name: string, branch?: Branch ) => {
		const branchToCheck = inventoryLocation?.branch ?? branch
		if ( branchToCheck ) {
			const { data } = await queryInventoryLocations( { variables: { branchIds: [ branchToCheck.id.toString() ] } } )
			if ( data?.inventoryLocations ) {
				const matched = data.inventoryLocations.edges.find( ( edge ) => edge.node.name === name )
				if ( matched !== undefined && matched.node.id !== inventoryLocation?.id ) {
					return {
						isInvalid: true,
						error: 'Store already associated to this branch. Choose a new name or branch.',
					}
				}
			}
		}
		return { isInvalid: false }
	}
}
